import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { register } from 'swiper/element/bundle';

register();

@Directive({
    selector: '[swiperElement]',
    standalone: false
})
export class SwiperDirective implements AfterViewInit {
  private readonly swiperElement: HTMLElement | any;
  @Input('config')
  config?: SwiperOptions;

  constructor(private element: ElementRef<HTMLElement>) {
    this.swiperElement = element.nativeElement;
  }

  ngAfterViewInit(): void {
    Object.assign(this.element.nativeElement, this.config)
    //@ts-ignore - There is no initialize method on the HTMLElement
    this.element.nativeElement.initialize();
  }
}